import React from 'react';
import { motion } from 'framer-motion';
import SectionShell from './Chapter';
import { SITE } from '@/constants/testIds';

const SECTORS = [
  {
    code: '01',
    name: 'Consumer & Retail',
    body:
      'Branded consumer, D2C, food & beverage, specialty retail and consumer platforms.',
  },
  {
    code: '02',
    name: 'Financial Services',
    body:
      'Non-banking financial companies, wealth, fintech and specialty finance platforms.',
  },
  {
    code: '03',
    name: 'Industrials & Manufacturing',
    body:
      'Advanced manufacturing, engineering, chemicals and industrial platforms with export exposure.',
  },
  {
    code: '04',
    name: 'Infrastructure & Real Assets',
    body:
      'Roads, ports, logistics parks, urban infrastructure and asset-heavy operating platforms.',
  },
  {
    code: '05',
    name: 'Technology & Digital',
    body:
      'B2B SaaS, enterprise software, digital-native platforms and technology-enabled services.',
  },
  {
    code: '06',
    name: 'Healthcare & Life Sciences',
    body:
      'Hospitals, diagnostics, pharma services, medical devices and healthtech platforms.',
  },
  {
    code: '07',
    name: 'Real Estate & Hospitality',
    body:
      'Grade-A commercial, hospitality platforms, mixed-use developments and REIT-ready assets.',
  },
  {
    code: '08',
    name: 'Energy & Sustainability',
    body:
      'Renewables, energy transition, green fuels and sustainability-linked infrastructure.',
  },
];

export const Sectors = () => {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <SectionShell
      id="sectors"
      testId={SITE.sectors}
      theme="dark"
      index="04"
      eyebrow="Selected Sectors"
      title={
        <>
          Sectors we understand deeply enough to be useful in the second
          meeting.
        </>
      }
      intro="We work with founders, promoters and family offices across a set of sectors where our operating experience and network create tangible advantage on live mandates."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8">
        {SECTORS.map((s, i) => (
          <motion.article
            key={s.code}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.06, ease }}
            className="border-t border-[color:var(--rule-dark-2)] pt-6 pb-2 group"
          >
            <div className="flex items-baseline justify-between small-caps text-[11px] text-[color:var(--stone-3)]">
              <span className="text-[color:var(--gold-2)]">{s.code}</span>
              <span>Sector</span>
            </div>
            <h3 className="mt-5 font-serif text-[22px] leading-[1.15] tracking-[-0.01em] text-[color:var(--stone)] group-hover:text-[color:var(--gold-2)] transition-colors">
              {s.name}
            </h3>
            <p className="mt-3 text-[13.5px] leading-[1.55] text-[color:var(--stone-2)]">
              {s.body}
            </p>
          </motion.article>
        ))}
      </div>
    </SectionShell>
  );
};

export default Sectors;
